import React, { useState, useEffect } from 'react'
import { Button, Card, CardContent, Typography, CircularProgress, Box } from '@mui/material'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import axios from 'axios'
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../Store/store'
import { updateTermsAndConditionsData } from '../../../../Store/slices/settingsSlice'

export default function TermsAndConditions() {
    const [termsContent, setTermsContent] = useState('')
    const [loading, setLoading] = useState(false)
    const [fetching, setFetching] = useState(true)

    const { accessToken } = useSelector((state: any) => state.auth.value)
    const { termsAndConditionsData } = useSelector((state: RootState) => state.settings.value)
    const dispatch = useDispatch()

    // API Endpoints
    const FETCH_TERMS_URL = 'https://us-central1-prenataldiet.cloudfunctions.net/getTermsAndConditions'
    const UPDATE_TERMS_URL = 'https://us-central1-eatwellmamav2.cloudfunctions.net/updateTermsAndConditions'

    // Quill editor configuration
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean']
        ],
    }

    const formats = [
        'header', 'bold', 'italic', 'underline', 'strike',
        'color', 'background', 'list', 'bullet', 'indent',
        'align', 'link', 'image'
    ]

    // Fetch current terms and conditions

    // Update terms and conditions
    const updateTermsAndConditions = async () => {
        if (!termsAndConditionsData.termsAndConditionsHTML.trim()) {
            toast.error('Lütfen içerik girin')
            return
        }

        setLoading(true)
        try {
            await axios.post(
                UPDATE_TERMS_URL,
                {
                    termsAndConditions: termsAndConditionsData.termsAndConditionsHTML
                },
                {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                }
            )
            toast.success('Şartlar ve koşullar başarıyla güncellendi!')
        } catch (error) {
            console.error('Error updating terms:', error)
            toast.error('Güncelleme sırasında hata oluştu')
        } finally {
            setLoading(false)
        }
    }


    if (termsAndConditionsData === null) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress />
                <Typography variant="body1" sx={{ ml: 2 }}>
                    Terms and Conditions Loading...
                </Typography>
            </Box>
        )
    }

    return (
        <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
            <Card>
                <CardContent>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Terms and Conditions Edit
                    </Typography>

                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        You can edit the terms and conditions content of the application on this page.
                        It is saved in HTML format and displayed in the application.
                    </Typography>

                    <Box sx={{ mt: 3, mb: 2 }}>
                        <ReactQuill
                            theme="snow"
                            value={termsAndConditionsData.termsAndConditionsHTML}
                            onChange={(content) => dispatch(updateTermsAndConditionsData({ ...termsAndConditionsData, termsAndConditionsHTML: content }))}
                            modules={modules}
                            formats={formats}
                            style={{
                                height: '400px',
                                marginBottom: '50px'
                            }}
                            placeholder="Write the terms and conditions content here..."
                        />
                    </Box>

                    <Box sx={{ mt: 4, display: 'flex', gap: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={updateTermsAndConditions}
                            disabled={loading}
                            size="large"
                        >
                            {loading ? (
                                <>
                                    <CircularProgress size={20} sx={{ mr: 1 }} />
                                    Updating...
                                </>
                            ) : (
                                'Update Terms and Conditions'
                            )}
                        </Button>

                    </Box>

                    {/* Preview Section */}
                    {termsAndConditionsData.termsAndConditionsHTML && (
                        <Box sx={{ mt: 4 }}>
                            <Typography variant="h6" gutterBottom>
                                Preview:
                            </Typography>
                            <Card variant="outlined" sx={{ p: 2, maxHeight: '300px', overflow: 'auto' }}>
                                <div
                                    dangerouslySetInnerHTML={{ __html: termsAndConditionsData.termsAndConditionsHTML }}
                                    style={{
                                        fontFamily: 'inherit',
                                        lineHeight: 1.6
                                    }}
                                />
                            </Card>
                        </Box>
                    )}
                </CardContent>
            </Card>
        </div>
    )
}
